let language = {
    PREFERENCE_EDITOR_TITLE: "货币设置",
    PREFERENCE_EDITOR_SUBTITLE1: "{{appName}}网站定价货币",
    PREFERENCE_EDITOR_BODY2: "点击下面的按钮更改{{appName}}网站的定价货币。",
    PREFERENCE_EDITOR_APPLY: "提交",
    PREFERENCE_EDITOR_RETRY_GET_LIST: "重试",
    // TODO: Error code

}
export { language }